import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {MONTHS, generateDaysInMonth} from '../shared/dateTimeLists';
import JobInputTitle from './JobInputTitle';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

const listInputStyles = {
    container: {margin: '0 0 1em 0'}
};

class JobMonthDayInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datesList: generateDaysInMonth(31),
            monthsList: this.processMonths(MONTHS),
            selectedMonth: this.processDefaultValue(props.defaultValue).month,
            selectedDate: this.processDefaultValue(props.defaultValue).day
        };
    }

    processDefaultValue(dv) {
        let dvArr = null;
        if (dv && dv.length === 5 && dv.indexOf('-') !== -1) {
            dvArr = dv.split('-');
        }
        return {
            month: (dvArr) ? dvArr[0] : null,
            day: (dvArr) ? dvArr[1] : null
        };
    }

    processMonths(list) {
        for (let i = 0; i < list.length; i++) {
            list[i].display_name = list[i].name;
        }
        return list;
    }

    processDays(selectedMonth) {
        let limit = 31;
        if (selectedMonth) {
            const mo = selectedMonth.toString();
            const month = MONTHS.find(r => r.id === mo);
            if (month) {
                limit = month.days;
            }
        }
        this.setState({
            datesList: generateDaysInMonth(limit)
        });
    }

    handleSelectMonth = (event, index, value) => {
        let selectedItem = (index) ? index : null;
        this.setState({
            selectedMonth: selectedItem,
            selectedDate: null
        }, () => {
            this.processDays(selectedItem);
            this.selectMonthDate();
        });
    };

    handleSelectDate = (event, index, value) => {
        let selectedItem = (index) ? index : null;
        this.setState({
            selectedDate: selectedItem
        }, () => {
            this.selectMonthDate();
        });
    };

    selectMonthDate = () => {
        const selectedMonth = this.state.selectedMonth;
        const selectedDate = this.state.selectedDate;

        if (selectedMonth && selectedDate && typeof this.props.onItemSelect === 'function') {
            const monthDate = selectedMonth.toString() + '-' + selectedDate.toString();
            this.props.onItemSelect('MonthDay', this.props.name, monthDate);
        }
    };

    render() {
        const {
            label,
            param,
            required,
            tooltip
        } = this.props;

        const {
            monthsList,
            datesList,
            selectedMonth,
            selectedDate
        } = this.state;

        return (
            <div style={listInputStyles.container}>
                <JobInputTitle label={label} tooltip={tooltip}/>

                <span className="Select-container inline">
                    <Field name={`${param}_month_id`}
                           component={VirtualizedSelectInput}
                           choices={monthsList}
                           label={`Month${(required) ? ' *' : ''}`}
                           optionText="display_name"
                           optionValue="id"
                           required={required}
                           onChange={this.handleSelectMonth}
                           allowEmpty
                           options={{
                               className: "has-label",
                               clearable: true,
                               placeholder: `Month${(required) ? ' *' : ''}`
                           }}
                           defaultValue={(selectedMonth) ? selectedMonth : undefined}
                    />
                </span>
                <span className="Select-container inline">
                    <Field name={`${param}_date_id`}
                           component={VirtualizedSelectInput}
                           choices={datesList}
                           label={`Day${(required) ? ' *' : ''}`}
                           optionText="name"
                           optionValue="id"
                           required={required}
                           onChange={this.handleSelectDate}
                           allowEmpty
                           options={{
                               className: "has-label",
                               clearable: true,
                               placeholder: `Day${(required) ? ' *' : ''}`
                           }}
                           defaultValue={(selectedDate) ? selectedDate : undefined}
                           disabled={(!selectedMonth)}
                    />
                </span>
            </div>
        )
    }
}

const defaultPropType = PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
]);

JobMonthDayInput.propTypes = {
    defaultValue: defaultPropType,
    label: PropTypes.string,
    name: PropTypes.string,
    nativeType: PropTypes.string,
    onItemSelect: PropTypes.func,
    param: PropTypes.string,
    required: PropTypes.bool,
    reset: PropTypes.bool,
    returnKey: PropTypes.string,
    tooltip: PropTypes.string
};

JobMonthDayInput.defaultProps = {
    defaultValue: [],
    name: 'location',
    param: 'location',
    nativeType: 'str',
    required: false,
    reset: false,
    returnKey: 'id'
};

export default JobMonthDayInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobMonthDayInput.js